module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-suroviny"
    }
  }, [_c('h1', [_vm._v("Jaký bude váš Pettime?")]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isStepValid() && this.tryEscape),
      expression: "!isStepValid() && this.tryEscape"
    }],
    staticClass: "info-messages-box"
  }, [(!_vm.isStepValid() && this.tryEscape) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("\n            Vyberte jednu z možností\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.existValidOption) ? _c('div', [_vm._v("Pro vašeho psa nedokážeme vytvořit krmivo.")]) : _vm._e()]), _vm._v(" "), (_vm.typSlozkyItems) ? _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "summary-subtitle"
  }, [_vm._v("Doporučujeme předvybraný Pettime, který obsahuje vše, co váš pes aktuálně potřebuje a za výhodnou cenu.")]), _vm._v(" "), _c('div', {
    staticClass: "suroviny"
  }, [(_vm.typSlozkyItems[0]) ? _c('div', {
    staticClass: "suroviny-skupina"
  }, [_c('div', {
    staticClass: "form-radios",
    class: {
      'has-error': !_vm.isMasovaValid() && this.tryEscape
    }
  }, _vm._l((_vm.typSlozkyItems[0].items), function(item, index) {
    return _c('div', {
      key: item.id,
      class: {
        'form-type-radio': true,
        'form-type-radio-disabled': item.alergic || item.status == 0,
          'pripravujeme': item.status == 0,
          'smaller': index > 0,
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.suroviny.slozky[_vm.typSlozkyItems[0].id_typ_slozky]),
        expression: "mazlicek.suroviny.slozky[typSlozkyItems[0].id_typ_slozky]"
      }],
      attrs: {
        "type": "radio",
        "name": _vm.typSlozkyItems[0].id_typ_slozky,
        "id": item.id,
        "disabled": item.alergic || item.status == 0
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.mazlicek.suroviny.slozky[_vm.typSlozkyItems[0].id_typ_slozky], item.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.mazlicek.suroviny.slozky, _vm.typSlozkyItems[0].id_typ_slozky, item.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item.id
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.description.length > 0) ? _c('div', {
      staticClass: "item-desc",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }) : _vm._e(), _vm._v(" "), (item.alergic) ? _c('div', {
      staticClass: "suroviny-alergic-info"
    }, [_c('div', {
      staticClass: "suroviny-alergic-info-icn"
    }), _c('div', {
      staticClass: "suroviny-alergic-info-desc"
    }, [_vm._v("Obsahuje vyloučenou surovinu")])]) : _vm._e(), _vm._v(" "), (item.status == 0) ? _c('div', {
      staticClass: "suroviny-pripravujeme-info"
    }, [_c('div', {
      staticClass: "suroviny-pripravujeme-info-icn"
    }), _c('div', {
      staticClass: "suroviny-pripravujeme-info-desc"
    }, [_vm._v("Připravujeme")])]) : _vm._e(), _vm._v(" "), (item.filename) ? _c('img', {
      attrs: {
        "src": _vm.getSlozkaImageUrl(item.filename)
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === 0),
        expression: "index === 0"
      }],
      staticClass: "dalsi-suroviny-info"
    }, [_vm._v("\n                          Možné úpravy "), _c('span', {
      staticClass: "parentheses"
    }, [_vm._v("(zvýšení ceny)")])])])
  }), 0)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('info', {
    attrs: {
      "krok": 9
    }
  }), _vm._v(" "), (_vm.priceConfirmation.showModal) ? _c('confirmation-modal', {
    attrs: {
      "old-price": _vm.priceConfirmation.oldPrice,
      "new-price": _vm.priceConfirmation.newPrice,
      "confirm-callback": _vm.updateProductAndQuit
    },
    on: {
      "close": function($event) {
        _vm.priceConfirmation.showModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('navigace', {
    attrs: {
      "showPrev": true,
      "onClickPrev": _vm.prev,
      "showNext": true,
      "disableNext": !_vm.valid,
      "onClickNext": _vm.next,
      "onClickSaveAndQuit": _vm.saveAndQuit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3997f3ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/09Suroviny.vue
// module id = 569
// module chunks = 1